import { useEffect, type ReactNode } from 'react';
import { Icon } from '@/lib/icons';

/* The leadIQ modal chrome (lead-modal classes), as a reusable shell. Escape and
   the scrim close it; clicks inside the card do not. */
export function Modal({ title, onClose, children, footer, wide }: {
  title: string; onClose: () => void; children: ReactNode; footer?: ReactNode; wide?: boolean;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="lead-modal" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`lead-modal__card ${wide ? 'lead-modal__card--wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className="lead-modal__head">
          <h3>{title}</h3>
          <button type="button" className="lead-modal__x" onClick={onClose} aria-label="Close"><Icon name="x" size={18} /></button>
        </div>
        <div className="lead-modal__body">{children}</div>
        {footer && <div className="lead-modal__foot">{footer}</div>}
      </div>
    </div>
  );
}

export function FormError({ error }: { error: unknown }) {
  if (!error) return null;
  return <p className="crm-error" role="alert">{errorMessage(error)}</p>;
}

/* API errors carry a JSON body with a human `message` when the server has one. */
export function errorMessage(error: unknown): string {
  if (!(error instanceof Error)) return 'Something went wrong.';
  const body = error.message.replace(/^API \d+: /, '');
  try { return (JSON.parse(body) as { message?: string; error?: string }).message ?? 'Something went wrong.'; }
  catch { return error.message; }
}
